import { UserDetails, UserId, UserRights } from './user.entity';

export class UpdateUser extends UserDetails {
    Id?: UserId;
    Login: string;
    Rights: UserRights;
}
